import { Outlet } from 'react-router-dom';
import { Layout as AntdLayout } from 'antd';

/**
 * Layout global: header con el logo COFASA + content area que renderiza
 * la página activa via <Outlet /> de react-router-dom.
 *
 * Si el logo no carga por cualquier motivo, el header igual queda visible
 * con el espaciado, solo desaparece el <img>.
 */
export function Layout() {
  return (
    <AntdLayout style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <AntdLayout.Header
        style={{
          background: '#fff',
          textAlign: 'center',
          padding: '12px 16px',
          height: 'auto',
          lineHeight: 'normal',
          boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
        }}
      >
        <img
          src="/logo-cofasa.png"
          alt="COFASA"
          style={{
            maxHeight: 48,
            maxWidth: '70%',
            verticalAlign: 'middle',
          }}
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = 'none';
          }}
        />
      </AntdLayout.Header>

      <AntdLayout.Content>
        <Outlet />
      </AntdLayout.Content>
    </AntdLayout>
  );
}
